var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7164 9.99517C19.7164 15.5064 15.301 19.9904 9.85668 19.9904C4.42186 19.9904 0 15.5064 0 9.99517C0 4.47746 4.42186 0 9.85668 0C15.301 0 19.7164 4.47746 19.7164 9.99517ZM12.5917 6.23908L8.78136 12.4085L7.0341 10.19C6.78579 9.87372 6.54481 9.76005 6.22564 9.76005C5.70415 9.76005 5.28319 10.1878 5.28319 10.7196C5.28319 10.9797 5.37126 11.2088 5.56111 11.4492L7.83421 14.2336C8.11301 14.5903 8.42569 14.7641 8.80717 14.7641C9.18567 14.7641 9.51682 14.5712 9.74837 14.2214L14.1544 7.31808C14.3009 7.08328 14.4087 6.83847 14.4087 6.60933C14.4087 6.06745 13.94 5.69459 13.425 5.69459C13.1011 5.69459 12.8163 5.88146 12.5917 6.23908Z",
    fill: "#101011"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListTick);
export default __webpack_public_path__ + "static/media/ListTick.1d799ac1cd92518c0640ee7822fb2a55.svg";
export { ForwardRef as ReactComponent };